import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGenericState } from '../../../../packages/kiti/components/helpers/GenericState'
import Dropdown from '../../../../packages/kiti/components/navigation/Dropdown'

const ComplianceTypeDropdown = () => {
  const { t } = useTranslation('common')
  const { value, handleChange } = useGenericState()

  const OPTIONS = [
    { id: 'service_order', name: t('widgets.activities') },
    { id: 'form', name: t('widgets.forms') }
  ]

  return (
    <Dropdown
      label={value?.nonComplianceType?.name || t('widgets.activities')}
      onChange={handleChange('nonComplianceType')}
      options={OPTIONS}
      placement="bottomRight"
    />
  )
}

export default ComplianceTypeDropdown
